
		<div [@state]="state" class="app-expand-collapse">
			<ng-content></ng-content>
		</div>
	